import { useTheme } from '@emotion/react';
import { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import {
  ACHIEVEMENT_FALLBACK_TYPES,
  ACHIEVEMENT_TIERS,
} from '@didaskill/domain/user-achievements/constants';
import { Achievement, Typography } from '@didaskill/ui/design-system';
import { achievementMessages } from '@didaskill/ui/intl';

import * as styles from '../AchievementsDrawer.styles';
import { TIER_STARS_COLOR_GROUP_MAP } from '../constants';
import { StarsOrnament } from '../stars-ornament/StarsOrnament';
import messages from './AchievementsDrawerIntro.messages';

const AchievementsDrawerIntroBase = () => {
  const theme = useTheme();

  const achievement = {
    type: ACHIEVEMENT_FALLBACK_TYPES.DEFAULT_MULTIPLE,
    tier: ACHIEVEMENT_TIERS.GOLD,
  };

  return (
    <div css={styles.achievementsDrawerBody}>
      <div css={styles.achievementWithStars}>
        <div css={styles.stars}>
          <StarsOrnament colorGroup={TIER_STARS_COLOR_GROUP_MAP(theme)[achievement.tier]} />
        </div>

        <Achievement
          size={Achievement.SIZES.GIANT}
          tier={achievement.tier}
          type={achievement.type}
        />
      </div>

      <div css={styles.content}>
        <Typography variant={Typography.VARIANTS.HEADING_3}>
          <FormattedMessage
            {...achievementMessages[achievement.type][achievement.tier].CATCH_PHRASE}
          />
        </Typography>

        <Typography variant={Typography.VARIANTS.BODY_LARGE_REGULAR}>
          <FormattedMessage {...messages.CONTENT} />
        </Typography>
      </div>
    </div>
  );
};

AchievementsDrawerIntroBase.displayName = 'AchievementsDrawerIntro';

export const AchievementsDrawerIntro = memo(AchievementsDrawerIntroBase);
